import React, { useState, useEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { AppContext } from "../../Context/Provider";
import { IoTrashOutline } from "react-icons/io5";
import { HiOutlinePencilSquare } from "react-icons/hi2";

function HomeStatisticsTitle() {
  const {
    CreateStatisticsTitles,
    FetchStatisticsTitles,
    StatisticsTitleData,
    UpdateStatisticsTitles,
    DeleteStatisticsTitles,
    User,
  } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filtertext, setfiltertext] = useState("");
  const [Title, setTitle] = useState("");
  const [Description, setDescription] = useState(""); // Corrected variable name
  const [error, setError] = useState("");
  const [currentId, setCurrentId] = useState(""); // Corrected spelling
  const [isLoading, setIsLoading] = useState(false);
  const [editMode, setEditMode] = useState(false); // New state to track edit mode
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteId, setDeleteId] = useState("");

  useEffect(() => {
    FetchStatisticsTitles();
  }, []);

  const handleEdit = (row) => {
    console.log("Edit row: ", row);
    setTitle(row.title);
    setCurrentId(row._id);
    setDescription(row.description);
    // Reset file input
    setShowModal(true);
    setEditMode(true); // Enable edit mode
  };
  const handleDelete = (rowId) => {
    setDeleteId(rowId); // Set the ID to delete
    setShowDeleteModal(true); // Show delete modal
  };

  const handleConfirmDelete = async () => {
    try {
      await DeleteStatisticsTitles(deleteId);
      setDeleteId("");
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Failed to delete the item:", error);
      // Optionally, show an error message to the user
    }
  };
  const columns = [
    { name: "Title", selector: (row) => row.title, grow: 1 },

    {
      name: "Description",
      selector: (row) => row.description,
      grow: 2,
      cell: (row) => (
        <div style={{ whiteSpace: "normal" }}>{row.description}</div>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEdit(row)}
            className="text-custom-green hover:text-blue-700"
          >
            <HiOutlinePencilSquare />
          </button>
          <button
            onClick={() => handleDelete(row._id)}
            className="text-custom-red hover:text-custom-yellow"
          >
            <IoTrashOutline />
          </button>
        </div>
      ),
      button: true,
      grow: 0.5,
    },
  ];
  const customStyles = {
    rows: {
      style: {
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
        backgroundColor: "#f8f9fa",
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
      },
    },
  };
  const ClearData = () => {
    setTitle("");
    setDescription("");
    setError("");
    setCurrentId("");

    setEditMode(false); // Reset edit mode
  };

  const filteredItems = StatisticsTitleData?.filter((item) => {
    return columns.some((column) => {
      const value = column.selector ? column.selector(item) : null;
      return (
        value &&
        value.toString().toLowerCase().includes(filtertext.toLowerCase())
      );
    });
  });

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <div className="flex flex-col items-end space-y-2 w-full p-4">
        <button
          onClick={() => {
            setShowModal(true);
            ClearData();
          }}
          className="px-4 py-2 bg-custom-green text-white rounded"
        >
          + Add
        </button>
        <input
          type="text"
          onChange={(e) => setfiltertext(e.target.value)}
          value={filtertext}
          placeholder="Search here"
          className="border rounded p-2 w-full max-w-xs"
        />
      </div>
    );
  }, [filtertext, resetPaginationToggle]);

  const handleTitleChange = (e) => {
    const inputValue = e.target.value;
    // Set maximum length for title
    const maxLength = 90; // Adjust this value as needed
    if (inputValue.length <= maxLength) {
      setTitle(inputValue);
    } else {
      // Optionally show an error message or trim the input
      const truncatedValue = inputValue.slice(0, maxLength);
      setTitle(truncatedValue);
    }
  };

  const handleDescriptionChange = (e) => {
    const inputValue = e.target.value;
    // Set maximum length for description
    const maxLength = 250; // Adjust this value as needed
    if (inputValue.length <= maxLength) {
      setDescription(inputValue);
    } else {
      // Optionally show an error message or trim the input
      const truncatedValue = inputValue.slice(0, maxLength);
      setDescription(truncatedValue);
    }
  };
  const handleAddOrUpdate = async () => {
    const data = {
      title: Title, // Matches the schema field name
      description: Description,
      userId: User?.data?.id, // Ensure this is included
    };

    if (!Title || !Description) {
      setError("Please fill out all fields.");
      return;
    }
    setIsLoading(true);
    try {
      if (editMode) {
        await UpdateStatisticsTitles(currentId, data);
      } else {
        await CreateStatisticsTitles(data);
      }
    } catch (err) {
      // Handle any potential errors from the API calls
      console.error(err);
      setError("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
      ClearData();
      setShowModal(false);
    }
  };

  return (
    <div className="px-8 py-2">
      {/* <h1 className="text-2xl font-semibold mb-4">Sercice</h1> */}

      <DataTable
        columns={columns}
        data={filteredItems}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        persistTableHead
        customStyles={customStyles}
      />

      {showModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-xl">
            <h2 className="text-xl font-bold mb-4  ">
              {editMode ? "Edit" : "Add"} Statistics Header
            </h2>
            <div className="grid grid-cols-12 gap-4 mb-4">
              <div className="col-span-12">
                <label className="block text-gray-700 mb-2">Title</label>
                <input
                  type="text"
                  value={Title}
                  onChange={handleTitleChange}
                  className={`w-full p-2 border rounded ${
                    !Title && error ? "border-red-500" : ""
                  }`}
                  placeholder="Enter Title"
                />
              </div>

              <div className="col-span-12">
                <label className="block text-gray-700 mb-2">Description</label>
                <textarea
                  value={Description}
                  onChange={handleDescriptionChange}
                  className={`w-full p-2 border rounded ${
                    !Description && error ? "border-red-500" : ""
                  }`}
                  placeholder="Enter Description"
                  rows={4}
                />
              </div>
            </div>

            {/* <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-red-500 text-white rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleAddOrUpdate}
                className="px-4 py-2 bg-green-500 text-white rounded"
              >
                {editMode ? "Update" : "Add"}
              </button>
            </div> */}
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => {
                  setShowModal(false);
                  ClearData();
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                onClick={handleAddOrUpdate}
                className={`px-4 py-2 rounded ${
                  isLoading ? "bg-gray-400" : "bg-custom-green"
                } text-white`}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : editMode ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-sm">
            <h2 className="text-xl font-bold mb-4 text-red-400 text-center">
              Are you sure?
            </h2>

            <p className="text-gray-700 mb-4">
              Are you sure you want to delete this record?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                  setDeleteId("");
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmDelete}
                className="px-4 py-2 bg-red-500 text-white rounded"
              >
                Yes,Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default HomeStatisticsTitle;
